import React from 'react';
import { Link } from 'react-router-dom';

const MobileHeader: React.FC = () => {
    return (
        <header className="md:hidden bg-white border-b border-gray-200 sticky top-0 z-40">
            <div className="px-4 py-3 flex items-center justify-center">
                <Link to="/courses" className="hover:opacity-80 transition-opacity">
                    <h1 className="text-2xl font-semibold text-gray-700">
                        🧠 Focus Helper
                    </h1>
                </Link>
            </div>
        </header>
    );
};

export default MobileHeader;